export const computeModelSelectorUrl = modelInfo => shoppingLinks => {
  const { isFamilyFirst, isCvo, defaultModelSelectorUrl, year } = modelInfo;
  if (isCvo) {
    return `${defaultModelSelectorUrl}`;
  }
  if (isFamilyFirst) {
    return `${defaultModelSelectorUrl}?year=${year}`;
  }
  return shoppingLinks.modelselector || defaultModelSelectorUrl;
};
